<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :rowClick="rowClickCallBack"
    :persistenceKey="'customer-statement-list'"
    :gcPopupCustomerStatementConfig="gcPopupCustomerStatementConfig"
  />
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";

import TransactionListTemplate from "../../templates/transaction-list";
// import { FeatureStorage } from "../../_services/storage";
import {
  CustomerTabs,
  GetIndexByTabName,
} from "../../_models/tabdata/customer/customer-tabs";

export default {
  props: {},
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  data() {
    return {
      gcPopupCustomerStatementConfig: {},
    };
  },
  computed: {
    setScreenConfig() {
      var config = {
        title: "Customers",
        selectedIndex: GetIndexByTabName("Statements"),
        tabs: CustomerTabs,
        exportFileName: "Customer Statement List",
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CustomerStatementRunList",
              filter: "",
              serverPaging: true,
              allowGrouping: false,
            },
            rowSelect: {
              view: this,
              page: "customer-statement",
              mode: "review",
              idProperty: "RunId",
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Statements",
                message: "Get Started, Add a Statement",
              },
            },
          },

          toolbar: {
            search: false,
            columnChooser: true,
            export: false,
            openFilter: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                route: "/customer-statement/create",
                clickAction: {},
                buttonLocation: "left",
              },
            ],
          },
          columns: [
            {
              screenField: "RunNo",
              dataField: "RunId",
              label: "Run ID",
              allowHiding: false,
              sortOrder: "desc",
              sortIndex: 0,
              maxWidth: 100,
            },
            {
              screenField: "Date",
              label: "Statement Date",
              filterLabel: "Statement Date",
              dataField: "StatementDate",
              filterDataField: "StatementDate",
              filterIndex: 0,
              maxWidth: 100,
            },
            {
              screenField: "Total",
              dataField: "TotalMails",
              label: "# Emails",
              format: "Decimal-16-0",
              maxWidth: 60,
              width: 60,
            },
            {
              screenField: "StatementType",
              filterIndex: 2,
            },
            {
              screenField: "Status",
              gridDataField: "Status",
              filterDataField: "Status",
              filterIndex: 3,
              dataSourceConfig: {
                data: [
                  { key: "F", value: "Failed" },
                  { key: "Q", value: "Queued" },
                  { key: "S", value: "Sent" },
                ],
              },
              valueExpr: "key",
              displayExpr: "value",
              cellTemplate: "Status",
            },
            {
              screenField: "Date",
              label: "Activity Start Date",
              dataField: "ActivityStartDate",
              filterLabel: "Activity Start Date",
              filterDataField: "ActivityStartDate",
              visible: false,
              filterIndex: 1,
            },
            {
              screenField: "Total",
              dataField: "QueuedMails",
              label: "Queued Mails",
              format: "Decimal-16-0",
              visible: false,
            },
            {
              screenField: "Total",
              dataField: "FailedMails",
              label: "Failed Mails",
              format: "Decimal-16-0",
              visible: false,
            },
            {
              screenField: "Total",
              dataField: "SentMails",
              label: "Sent Mails",
              format: "Decimal-16-0",
              visible: false,
            },
            // Activity Start Date ([api].[CustomerStatementRunList].ActivityStartDate)
            // Queued Mails ([api].[CustomerStatementRunList].QueuedMails)
            // Failed Mails ([api].[CustomerStatementRunList].FialedMails)
            // Sent Mails ([api].[CustomerStatementRunList].SentMails)
          ],
        },
      };

      return config;
    },
  },
  methods: {
    goToCustomerStatementModel(e) {
      this.gcPopupCustomerStatementConfig = {
        visible: true,
        hidden: () => {
          this.gcPopupCustomerStatementConfig.visible = false;
        },
        dataModel: e,
      };
    },
    goToCreateCustomerReceipt(e) {
      this.$router.push({
        path: `/customer-receipt/create/${e.Code}`,
        query: {
          from: "customer-list",
        },
      });
    },
    goToCredit(e) {
      this.$router.push({
        path: `credit-customer/create/${e.Code}`,
      });
    },
    rowClickCallBack(e) {
      if (
        e.rowType == "data" &&
        e.column.screenField != "Status" &&
        e.column.screenField != "GridRecordEllipsisMenu"
      ) {
        // this.onRowClicked(e, {
        //   view: this,
        //   page: "customer",
        //   mode: "review",
        //   idProperty: "Code",
        // });
      }
    },
  },

  created() {},
};
</script>

<style lang="scss"></style>
